/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerListQueryResponse, IncidentInvestigationControllerListQueryParams } from "../../models/incidentAgentController/IncidentInvestigationControllerList";

function getIncidentInvestigationControllerListUrl() {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations}
 */
export async function incidentInvestigationControllerList(params?: IncidentInvestigationControllerListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerListUrl().url.toString(), params, ... requestConfig })  
  return res.data
}